/** @format */

import {
	FOOTER_HEIGHT,
	FOOTER_MARGIN,
} from "@local/commons/dist/components/Footer"

import { HEADER_HEIGHT } from "@local/commons/dist/components/Header"
import styled from "styled-components"

export const LayoutStyled = styled.div<{ hasNavigation : boolean}>`
	min-height: 100vh;
	${props => props.hasNavigation && "padding-left: 240px;"}
	${props => props.hasNavigation && "padding-top: 80px;"}
`
const minHeight = `100vh - (${HEADER_HEIGHT} + ${FOOTER_HEIGHT} + ${FOOTER_MARGIN})`
export const LayoutWrapperStyled = styled.div`
	min-height: calc(${minHeight});
	display: flex;
`
